"use strict";
(function(tp_trans) {
  function initResetButtonEventHandler() {
    var resetButtons = document.querySelectorAll('.btn-reset-plan');
    resetButtons.forEach(button => {
      button.addEventListener('click', onResetButtonClick);
    });
  }

  function onResetButtonClick(event) {
    const confirmed = confirm(tp_trans.trans('confirm_reset_button', 'confirm_reset_button'));
    if (!confirmed) {
      event.preventDefault();
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    initResetButtonEventHandler();
  });
})(window.tp_trans);
